const BASE_URL = process.env.REACT_APP_API_URL;

export async function getOperationalHealthTrends(perfCycleId, positionId) {
  const token = "Bearer " + localStorage.getItem("authToken");
  const res = await fetch(
    `${BASE_URL}v1/plans/operational-health-trends?perfCycleId=${perfCycleId}&positionId=${positionId}`,
    {
      headers: { Authorization: token, "Content-Type": "application/json" },
    }
  );
  return await res.json();
}

export async function getDepartmentEfficiency(perfCycleId, positionId) {
  const token = "Bearer " + localStorage.getItem("authToken");
  const res = await fetch(
    `${BASE_URL}v1/plans/department-efficiency?perfCycleId=${perfCycleId}&positionId=${positionId}`,
    {
      headers: { Authorization: token, "Content-Type": "application/json" },
    }
  );
  return await res.json();
}
